import React, { Component } from "react";

// import "../assets/css/alert.css";
import "../assets/css/alert-styles.css";

class AlertModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props,
      // startClicked: this.props.startClicked
    };
  }

  render() {
    return (
      <div
        className={"alert-container " + (this.props.alertHidden ? "hide" : "")}
      >
        <div className="alert-header-row">
          <div className="alert-header-item">
            <span>WARNING!!!</span>
          </div>
        </div>
        <div className="alert-items">
          <h1>
            Five Hours left to {this.props.firstHours} hour Schedule
            Inspection!{" "}
          </h1>
        </div>

        <div className="alert-button-container">
          <button
            className="a-button"
            onMouseOver={this.props.logSetToNeutral}
            onClick={() => {
              this.props.toggleAlert();
                this.props.stopAutoAlert();
                this.props.stopAutoAlertAudio();
                // this.props.addWarningClosedToLogs()
                // this.props.addDateAndTimeToLog()
            }}
          >
            STOP ALERT
          </button>
        </div>
      </div>
    );
  }
}

export default AlertModal;
